import { withNamespaces } from "react-i18next";
import { CardBody } from "reactstrap";

const ColumnHeader = ({
    t,
    title,
    subtitle
}) => {
    const newTitle = parseInt(subtitle) > 1 ? 'Cards' : 'Card';

    return (
        <CardBody>
            <h4 className='card-title'>{ t(title) }</h4>
            <p className='mb-1'>{`${t(subtitle)} ${t(newTitle)}`}</p>
        </CardBody>
    );
};

export default withNamespaces()(
    ColumnHeader
);